// extracted by mini-css-extract-plugin
export default {"container":"Favoritos_container__-o37T"};